import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = [
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/5-walls-1.svg`,
          },
        },
      },
    },
  ],
  [
    {
      variant: "blockContainer",
      data: {
        block: {
          type: "image",
          options: {
            src: `${config.ASSETS_URL}/01/24/principle/5-walls-2.svg`,
          },
        },
      },
    },
  ],
];

export default components;
